import definition from './health-checker.service';

export default {
    name: 'HealthCheckerService',
    definition
};
